"use client";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import "./../css/Accordion.css";

const AccordionItem = ({ title, children, isOpen, onClick }) => {
  return (
    <motion.div
      initial={false}
      animate={{ backgroundColor: isOpen ? "#F9F9F9" : "#F9F9F9" }}
      transition={{ duration: 0.2 }}
      className='faq-accordion-item'
    >
      <button className='faq-accordion-button' onClick={onClick}>
        <span className='faq-accordion-title'>{title}</span>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          {isOpen ? (
            <Minus className='faq-accordion-icon' />
          ) : (
            <Plus className='faq-accordion-icon' />
          )}
        </motion.div>
       
      </button>
      
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className='faq-accordion-content-wrapper'
          >
            <div className='faq-accordion-content'>{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

const Accordion = ({ items, allowMultipleOpen = false }) => {
  const [openIndexes, setOpenIndexes] = useState([]);

  const handleItemClick = (index) => {
    setOpenIndexes((prevIndexes) => {
      if (prevIndexes.includes(index)) {
        return prevIndexes.filter((i) => i !== index);
      } else {
        return allowMultipleOpen ? [...prevIndexes, index] : [index];
      }
    });
  };

  return (
    <div className='faq-accordion-container'>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          isOpen={openIndexes.includes(index)}
          onClick={() => handleItemClick(index)}
        >
          {item.content}
        </AccordionItem>
      ))}
    </div>
  );
};

export default Accordion;
